import { render } from "./ClientSignUp.vue?vue&type=template&id=8218e0de"
import script from "./ClientSignUp.vue?vue&type=script&lang=js"
export * from "./ClientSignUp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__